import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import loadable from '@loadable/component'

import "../css/Header.css";
import { UserSession } from "../modules/UserSession";
import { useSelector } from "react-redux";
import $ from "jquery";

export default function SMLSLoginModal(props) {

  const [validated, setValidated] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const [userName, setUserName] = useState(null);
  const [password, setPassword] = useState(null);
  const seeMyLoanFormDataRedux = useSelector((state) => state.nameReducer.seeMyLoanFormData);
  const [pricingData, setPricingData] = useState(
    seeMyLoanFormDataRedux && Object.keys(seeMyLoanFormDataRedux).length !== 0 ? seeMyLoanFormDataRedux : {})

  function serialize(form) {
    let inputs = form.elements;
    let testArray = {};
    for (let i = 0; i < inputs.length - 1; i++) {
      testArray[inputs[i].id] = inputs[i].value;
    }
    return testArray;
  }

  function postInput(id, val) {
    return (
      '<input style="display:none" type="text" name="' +
      id +
      '" value="' +
      val +
      '" />'
    );
  }

  const userSession = new UserSession();
  /** WHL-41: function to append pricing data, if sent  */
  const appendPricingData = () => {

    if(pricingData && Object.keys(pricingData).length !== 0){

      const {
        loanAmount,
        downPayment,
        cashOutAmount,
        fico,
        propertyZipCode,
        propertyState,
        propertyCountyCode,
        propertyTypeKeyword,
        occupancy,
        productCode,
        optionKeyword,
        loanPurposeKeyword,
        rate
      } = pricingData

      const cashOutData = userSession.getCashOutAmount() ? userSession.getCashOutAmount() : ''
      const appraisedValue = userSession.getEstimatedValue() ? userSession.getEstimatedValue() : ''

      let newLoanAmount = loanAmount
      if (
        (
          (userSession.getLoanPurposeCode() === 'PURCHASE') ||
          (userSession.getLoanPurposeCode() === 'PURCHASE REHAB') /** WHL-41: 203k may send this type of value */
        ) &&
        downPayment &&
        (parseInt(downPayment) > 0)
      ) newLoanAmount += downPayment 

      let newData = postInput("extLoanAmount", newLoanAmount) +
        postInput("extDownPayment", downPayment) +
        // postInput("extAppraisalAmount ", 0) +
        postInput("extCashOutAmount", cashOutData) +
        postInput("extCreditScore", fico) +
        postInput("extPropertyZip", propertyZipCode) +
        postInput("extPropertyState", propertyState) +
        postInput("extPropertyCounty", propertyCountyCode) +
        postInput("extPropertyType", propertyTypeKeyword) +
        postInput("extPropertyOccupancy", occupancy) +
        postInput("extProductCode", typeof productCode !== 'undefined' ? productCode : '') +
        postInput("extFhaSection", typeof optionKeyword !== 'undefined' ? optionKeyword : '') +
        postInput("extLoanPurpose", loanPurposeKeyword) + 
        postInput("extRate", rate) 

        if(
          (
            (userSession.getLoanPurposeCode() !== 'PURCHASE') &&
            (userSession.getLoanPurposeCode() !== 'PURCHASE REHAB') /** WHL-41: 203k may send this type of value */
          ) &&
          appraisedValue
        ) {
          newData += postInput("extAppraisalAmount", appraisedValue)
        }

      return newData
    } else return ''
  }

  const handleSubmit = async (event) => {
    setFormLoading(true);
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      setFormLoading(false);
    } else {
      setValidated(false);
      var url = process.env.REACT_APP_SMLS_LOGIN_URL;
      const newData = appendPricingData()
      var form1 = $(
        '<form action="' +
          url +
          '" method="post" style="display:none" >' +
          // parameter name       parameter value
          postInput("loginType", "originator") +
          postInput("userId", userName) +
          postInput("password", password) +
          postInput("action", props.actionType) +
          newData +
          //  postInput("loan",              $("#loanOrig").val()) +
          "</form>"
      );
      $("body").append(form1);
      form1.submit();
    }
  };

  return (
    <Modal className="input-eye-icon-none aqua-theme-wrapper" show={props.showModal} onHide={props.modalClose}>
      <Modal.Header className="aqua-theme-title-section" closeButton>
        <Modal.Title className="text-content">
          Login 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          className="need-validation"
          id="frmSMLSLogin"
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          <Form.Row className="mb-3">
            <Col>
              <Form.Label srOnly>User ID</Form.Label>
              <Form.Control
                type="text"
                name="userName"
                required
                value={userName}
                placeholder="Enter User ID"
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
                onKeyDown = {e => {
                  if(e.key === 'Enter') {
                    handleSubmit(e)
                  }
                }}
              />
              <Form.Control.Feedback type="invalid">
                User ID is required
              </Form.Control.Feedback>
            </Col>
          </Form.Row>
          <Form.Row className="mb-3">
            <Col>
              <Form.Label srOnly>Password</Form.Label>
              <Form.Control
                type="password"
                name="Password"
                placeholder="Enter Password"
                required
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                onKeyDown = {e => {
                  if(e.key === 'Enter') {
                    handleSubmit(e)
                  }
                }}
              />
              <Form.Control.Feedback type="invalid">
                Password is required
              </Form.Control.Feedback>
            </Col>
          </Form.Row>

          <Col className="px-0 pt-1 btnSubmit-Col text-center">
            <Button className="btnSubmit" type="submit">
              {formLoading ? (
                <div className='smlsLoader'><Spinner
                  as="span"
                  animation="border"
                  size="md"
                  role="status"
                  aria-hidden="true"
                /><span>{` Please wait...`}</span></div>
              ) : (
                "Submit"
              )}
            </Button>
          </Col>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
